var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6296 17.0926C29.6296 9.72876 23.66 3.75923 16.2962 3.75923C8.93243 3.75923 2.9629 9.72876 2.9629 17.0926C2.9629 24.4564 8.93243 30.4259 16.2962 30.4259C23.66 30.4259 29.6296 24.4564 29.6296 17.0926ZM16.2962 0.796265C25.2964 0.796265 32.5925 8.09237 32.5925 17.0926C32.5925 26.0928 25.2964 33.3889 16.2962 33.3889C7.29604 33.3889 -6.48499e-05 26.0928 -6.48499e-05 17.0926C-6.48499e-05 8.09237 7.29604 0.796265 16.2962 0.796265ZM13.7672 11.6006L9.32274 16.045C8.74418 16.6236 8.74418 17.5616 9.32274 18.1401L13.7672 22.5846C14.3457 23.1631 15.2838 23.1631 15.8623 22.5846C16.4409 22.006 16.4409 21.068 15.8623 20.4894L13.9469 18.574H22.2222C23.0404 18.574 23.7036 17.9108 23.7036 17.0926C23.7036 16.2744 23.0404 15.6111 22.2222 15.6111H13.9469L15.8623 13.6957C16.4409 13.1171 16.4409 12.1791 15.8623 11.6006C15.2838 11.022 14.3457 11.022 13.7672 11.6006Z",
    fill: "#407BFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.b1109605.svg";
export { ForwardRef as ReactComponent };